import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight, Layers } from "lucide-react";
import { SectionTitle } from "@/components/Shared";
import { AiBadge, IssueVisual } from "@/components/issues/IssueCard";
import { ISSUE_ICONS, STATUS_TONE } from "@/lib/issues";

// Three most recently updated approved Under-the-Lens issues as image tiles.
export default function LensStrip({ issues }) {
  const latest = issues.slice(0, 3);
  if (!latest.length) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-testid="lens-strip-section">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-10">
        <SectionTitle eyebrow="Under the Lens" title="Issues We Are Examining" />
        <Link to="/issues" className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.12em] text-npst-navy hover:text-npst-gold transition-colors" data-testid="lens-strip-view-all">
          View all <ArrowRight size={15} />
        </Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {latest.map((i, idx) => {
          const Icon = ISSUE_ICONS[i.icon] || Layers;
          return (
            <Link key={i.id} to={`/issues?issue=${i.slug}`} data-testid={`lens-tile-${i.slug}`}
              className={`group hover-lift flex flex-col overflow-hidden rounded-xl border border-npst-line bg-white ${idx === 2 ? "sm:col-span-2 lg:col-span-1" : ""}`}>
              <div className="relative h-56 overflow-hidden">
                <div className="absolute inset-0 transition-transform duration-[1000ms] ease-out group-hover:scale-[1.05]"><IssueVisual issue={i} /></div>
                <AiBadge className="absolute left-3 top-3" />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <span className="inline-flex items-center gap-2 label-eyebrow text-npst-gold"><Icon size={14} />{i.category}</span>
                <h3 className="mt-3 font-serif text-xl font-semibold leading-snug text-npst-ink group-hover:text-npst-navy">{i.title}</h3>
                <div className="mt-auto pt-4 flex items-center justify-between">
                  <span className="inline-flex items-center gap-2 rounded-full border border-npst-line bg-npst-bg px-2.5 py-1 text-[11px] text-npst-inkSoft">
                    <span className={`h-1.5 w-1.5 rounded-full ${STATUS_TONE[i.status_kind] || "bg-npst-gold"}`} />{i.status}
                  </span>
                  <ArrowUpRight size={16} className="text-npst-gold transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
